import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @title}}\n  <div class=\"icon-list__section-title title-4\" ...attributes>\n    {{@title}}\n  </div>\n{{/if}}", {
  moduleName: "@qonto/ui-kit/components/icon-list/section-title.hbs"
});